
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class IconWorld extends Vue {
  @Prop({ default: 16 }) public size!: number;
  @Prop({ default: "#000" }) public color!: string;
}
